import { StrictMode } from "react";
import ReactDOM from "react-dom";
import bootstrapIntl from "./Hoc/bootstrapIntl";
import { Global } from "@emotion/react";
import App from "./App";
import globalStyle from "./globalStyle";
import "bootstrap/dist/css/bootstrap.min.css";

async function bootstrap() {
    // Boot the MSW mock worker in dev before mounting the app.
    if (process.env.NODE_ENV === "development") {
        const { startMockWorker } = await import(
            "../dev-tool/mock/browser/setupMock"
        );
        await startMockWorker(process.env.WEBPACK_PUBLIC_PATH || "/");
    }

    const AppWithIntl = await bootstrapIntl(App);
    ReactDOM.render(
        <StrictMode>
            <Global styles={globalStyle}></Global>
            <AppWithIntl />
        </StrictMode>,
        document.getElementById("root"),
    );
}

bootstrap();
